<section class="section section-shaped">
  <div class="tw-mx-auto tw-w-full tw-max-w-[996px] tw-px-4">
    <div class="row justify-content-center">
      <div class="col-lg-12">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-2 progress-step" [class.active]="step == 1">
            <div
              class="pitchin-icon pitchin-icon-profile"
              [class.pitchin-icon-check-green]="step > 1"
            ></div>
            <div class="progress-title" [class.text-primary]="step >= 1">
              {{ 'registerInvestor.profile' | translate }}
            </div>
          </div>
          <div class="col-lg-1 p-0 d-none d-lg-flex">
            <div class="progress-line"></div>
          </div>
          <div class="col-lg-3 progress-step" [class.active]="step == 2">
            <div class="pitchin-icon pitchin-icon-coins"></div>
            <div class="progress-title" [class.text-primary]="step >= 2">
              {{ 'registerInvestor.investorType' | translate }}
            </div>
          </div>
        </div>
        @if (step == 1) {
          <div class="row justify-content-center mt-5">
            <div class="col-lg-8">
              <h2 class="text-center font-weight-extrabold">
                {{ 'registerInvestor.aboutYou' | translate }}
              </h2>
              <div class="text-center mb-4">{{ 'registerInvestor.subAboutYou' | translate }}</div>
              <form [formGroup]="form" [class.show-form-error]="showFormError">
                <div class="mb-3">
                  @if (!isLoading) {
                    <div class="input-field">
                      <div
                        class="profile-upload"
                        agmoUploader
                        [accept]="accept"
                        (selectFiles)="selectFile($event)"
                      >
                        @if (!profileImage) {
                          <div class="profile-image pitchin-icon-profile"></div>
                        }
                        @if (profileImage) {
                          <img class="profile-image" alt="pitchIN User" [src]="profileImage" />
                        }
                        <div class="pitchin-icon pitchin-icon-add"></div>
                      </div>
                    </div>
                  }
                  @if (!profileImage) {
                    <div class="text-primary text-center pt-3">
                      {{ 'common.dragAndDropImage' | translate }}
                    </div>
                  }
                  @if (profileImage) {
                    <div class="text-primary text-center pt-3">
                      {{ 'common.lookingGood' | translate }}
                    </div>
                  }
                  @if (isLoading) {
                    <agmo-loading></agmo-loading>
                  }
                </div>
                <div class="form-group">
                  <label class="input-label">{{ 'signUp.identificationType' | translate }}*</label>
                  <mat-select
                    [placeholder]="'common.selectPlaceholder' | translate"
                    class="form-control"
                    formControlName="userIdentityNoType"
                    (selectionChange)="changeIdentificationType()"
                  >
                    @for (type of IdentificationType | enumToArray; track type) {
                      <mat-option [value]="type.key">
                        {{ 'signUp.' + type.value | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
                <div class="form-group">
                  <label class="input-label">
                    {{ 'signUp.fullNameAsPer' | translate }}
                    {{ 'signUp.' + IdentificationType[form.value.userIdentityNoType] | translate }}*
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="{{ 'signUp.fullNamePlaceholder' | translate }}"
                    formControlName="fullName"
                  />
                </div>
                <div class="form-group">
                  <label class="input-label">
                    {{ 'signUp.' + IdentificationType[form.value.userIdentityNoType] | translate }}
                    {{ 'signUp.number' | translate }}*
                  </label>
                  @if (form.value.userIdentityNoType != IdentificationType.Passport) {
                    <input
                      class="form-control"
                      placeholder="{{ 'signUp.icNumberPlaceholder' | translate }}"
                      formControlName="identityNo"
                      [mask]="icMaskFormat"
                      type="text"
                    />
                  }
                  @if (form.value.userIdentityNoType == IdentificationType.Passport) {
                    <input
                      class="form-control"
                      placeholder="{{ 'signUp.passportPlaceholder' | translate }}"
                      formControlName="identityNo"
                      type="text"
                      alphanumeric
                    />
                  }
                  @if (
                    showFormError &&
                    form.controls.identityNo.errors &&
                    (form.controls.identityNo.errors.pattern ||
                      form.controls.identityNo.errors.mask)
                  ) {
                    <div class="error">
                      {{
                        'signUp.' + IdentificationType[form.value.userIdentityNoType] | translate
                      }}
                      {{ 'signUp.number' | translate }}
                      {{ 'signUp.incorrectFormat' | translate }}
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label class="input-label">{{ 'registerInvestor.aboutMe' | translate }}</label>
                  <textarea
                    class="form-control"
                    cols="30"
                    rows="5"
                    formControlName="aboutMe"
                    placeholder="{{ 'registerInvestor.aboutMePlaceHolder' | translate }}"
                  ></textarea>
                </div>
                <div class="d-flex justify-content-center mt-5">
                  <button class="btn btn-primary" (click)="next()">
                    {{ 'registerInvestor.next' | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        }
        @if (step == 2) {
          <div class="row justify-content-center mt-5">
            <div class="col-lg-12">
              <h2 class="text-center font-weight-extrabold">
                {{ 'registerInvestor.investorType' | translate }}
              </h2>
              <div class="text-center mb-5">
                {{ 'registerInvestor.selectInvestmentProfile' | translate }}
              </div>
              <app-investor-profile
                [investorProfile]="investorProfile"
                [isSettings]="false"
                (submitForm)="submit($event)"
              ></app-investor-profile>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
